import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { isRequired } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import TextInput from '../../../common/forms/input/TextInput';
import LocationSelect from '../../../common/forms/select/LocationSelect';
import { DATE_TIME_FORMAT } from '../../../../config/locale';

export const BusRetentionScheduleEditForm = ({
  handleSubmit,
  loading,
  onCancel,
}) => {
  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Desde" required>
          <Field
            name="fromDateString"
            component={TextInput}
            type="datetime-local"
            placeholder={DATE_TIME_FORMAT}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Hasta" required>
          <Field
            name="toDateString"
            component={TextInput}
            type="datetime-local"
            placeholder={DATE_TIME_FORMAT}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Ubicación" required>
          <Field
            name="location"
            component={LocationSelect}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormFooter>
        <Button
          type="button"
          color="secondary"
          className="mr-2"
          onClick={onCancel}
        >
          Cancelar
        </Button>
      </FormFooter>
    </Form>
  );
};

BusRetentionScheduleEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const mapStateToProps = ({ BusUnit }) => ({
  loading: !BusUnit.RegisteredBusFleet.getIn([
    'retention',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'BusRetentionScheduleEditForm',
})(BusRetentionScheduleEditForm);

export default connect(mapStateToProps)(formComponent);
